@if (paymentReceipt) {
  <div class="confirmationContainer">
    @if (!selectedPremium.isPaymentByCheck) {
      @if (selectedPremium.total>0) {
        <div>
          <p>
            Un montant de {{ selectedPremium.total |currencyCustom }} a été prélevé sur la carte de crédit numéro {{ paymentReceipt.creditCardNumber}}
            du titulaire {{ paymentReceipt.nameUnderCard }}
          </p>
          <p>
            Votre numéro de confirmation est le {{ paymentReceipt.referenceNumber }}
          </p>
          <p>
            Toutes les informations que vous avez fournies seront inscrites au Fonds d'assurance-responsabilité professionnelle de l'Ordre
            des dentistes du Québec.
          </p>
          <p>
            Une preuve d'assurance vous sera bientôt acheminée
          </p>
          <br/>
        </div>
      }
      @if (selectedPremium.total<=0) {
        <div>
          <p>
            Un montant de {{ selectedPremium.total |currencyCustom }} a été crédité dans votre compte
          </p>
        </div>
      }
    }
    @if (selectedPremium.isPaymentByCheck) {
      <p>
        Attention, vous devez faire parvenir votre paiement par chèque au plus tard le {{model.period.effectiveStartDate | date: 'yyyy/MM/dd'}} au:
      </p>
      <br/>
      <pre class="paymentParCheckText">
        Fonds d’assurance-responsabilité professionnelle de l’Ordre des dentistes du Québec
        800, boul. René-Lévesque Ouest, bureau 1645
        Montréal (Québec)
        H3B 1X9
        fonds&#64;farpodq.org
        514 875-4823 / 1 800 463-1204
      </pre>
    }
    <div class="confirmationButtonsDiv">
      <button mat-raised-button (click)="onDownloadConditions()">
        <mat-icon>summarize</mat-icon>
        Télécharger les conditions particulières
      </button>
      <button mat-raised-button (click)="onDownloadReceipt()">
        <mat-icon>receipt</mat-icon>
        Télécharger le reçu
      </button>
      <button mat-raised-button (click)="goToHomePage()">
        <mat-icon>receipt</mat-icon>
        Retourner à la page d'accueil
      </button>
    </div>
    <br/>
    @if (loadingReport$ | async) {
      <div
        class="spinner-container">
        <mat-spinner></mat-spinner>
      </div>
    }
  </div>
}

